import React, { FunctionComponent } from 'react'
import { connect } from 'react-redux'

import { AnyAction, Dispatch } from 'redux'

import { BaseModal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/baseModal/BaseModal'
import { toJS } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/hocs/toJS'

import * as ModalActions from './modal-actions'

interface GenericModalViewProps {
  isOpen: boolean
  showCloseButton: boolean
  content: string
  closeModal: () => void
}

const GenericModalView: FunctionComponent<GenericModalViewProps> = ({
  isOpen,
  closeModal,
  content,
  showCloseButton,
}) => {
  return <BaseModal isOpen={isOpen} showCloseButton={showCloseButton} body={content} closeModal={closeModal} />
}

const mapStateToProps = (state: any) => {
  const modal = state.modal ? state.modal : state.get('modal') // transitioning to redux-immutablejs...everything is immutable in redux-immutable
  return {
    isOpen: modal.get('isOpen'),
    content: modal.get('content', ''),
    showCloseButton: modal.getIn(['modalProps', 'showCloseButton'], true),
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
  return {
    closeModal: () => {
      dispatch(ModalActions.closeModal())
    },
  }
}

const GenericModalContainer = connect(mapStateToProps, mapDispatchToProps)(toJS(GenericModalView))

export default GenericModalContainer
